import React from 'react'

import {Badge, Card, Colors, P} from '../UI/index.js'
import t from 'src/helpers/Languages.js'
import {getETADeviation} from '@utils/routeETA.js'

// ETA deviation at the next stop of a started route. Shown to the messenger in the app and to the planner in the route panel.
export default function NextStopETA({route, style}: {route: any, style?: React.CSSProperties}) {
    const deviation = getETADeviation(route)

    if (deviation === null || !route?.started || route.completed) {
        return null
    }

    return (
        <Card shadow style={{flex: 'unset', width: 'calc(100% - 12px)', padding: '8px 12px', margin: 6, ...style}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <P>{t('nextStopETA')}</P>
                <Badge color={deviation > 0 ? Colors.errorDark : Colors.successDark}>{deviation >= 0 ? '+' : '-'} {t('etaDeviationDuration', Math.abs(deviation))}</Badge>
            </div>
        </Card>
    )
}
